import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ForgotResetPasswordService {
  reqResetPasswordResponse: any = {};
  onReqResetPasswordResponseChange: Subject<any> = new BehaviorSubject({});

  constructor(private http: HttpClient) {}

  requestResetPassword(payload: any) {
    return this.http.post(`${environment.apiUrl}/user/request-reset-password`, payload);
  }

  validatePWResetToken(token: any) {
    return this.http.post(`${environment.apiUrl}/user/validate-reset-password`, { token });
  }

  resetPassword(payload: any) {
    return this.http.post(`${environment.apiUrl}/user/reset-password`, payload);
  }

  requestResetPasswordNurse(payload: any) {
    return this.http.post(`${environment.apiUrl}/nurse/request-reset-password`, payload);
  }

  validatePWResetTokenNurse(token: any) {
    return this.http.post(`${environment.apiUrl}/nurse/validate-reset-password`, { token });
  }

  resetPasswordNurse(payload: any) {
    return this.http.post(`${environment.apiUrl}/nurse/reset-password`, payload);
  }

  requestResetPasswordClient(payload: any) {
    return this.http.post(`${environment.apiUrl}/client/request-reset-password`, payload);
  }

  validatePWResetTokenClient(token: any) {
    return this.http.post(`${environment.apiUrl}/client/validate-reset-password`, { token });
  }

  resetPasswordClient(payload: any) {
    return this.http.post(`${environment.apiUrl}/client/reset-password`, payload);
  }

}
